export const usersPermissions = {
  displayAllUsers: ["dashboard.can-display-all-users"],
  update: [
    "neoauth.can-update-users",
    "central-api.can-view-companies",
    "central-api.can-view-accounting-firms",
  ],
  create: [
    "neoauth.can-create-users",
    "central-api.can-view-companies",
    "central-api.can-view-accounting-firms",
  ],
  display: ["dashboard.can-display-users"],
};

export const updateProfilePermission = ["neoauth.can-update-profile"];

export const cpCollabPermission = ["neoauth.is-cp-collab"];
export const atcCollabPermission = ["neoauth.is-atc-collab"];
export const accountingFirmPermission = ["neoauth.is-accounting-firm"];
export const directorPermission = ["neoauth.is-director"];
export const helpdeskPermission = ["neoauth.is-helpdesk-collab"];

export const banksPermissions = {
  viewBanksList: ["banks-api.can-view-banks"],
  createBank: ["banks-api.can-create-banks"],
  updateBank: ["banks-api.can-update-banks"],
  deleteBank: ["banks-api.can-delete-banks"],
};
